import { Controller } from '@hotwired/stimulus'
import Tagify from '@yaireo/tagify'

export default class extends Controller {
  connect() {
    this.tagify = new Tagify(this.element, {
      delimiters: '_',
      originalInputValueFormat: (valuesArr) => valuesArr.map((item) => item.value).join('_')
    })
  }

  disconnect() {
    this.tagify?.destroy()
    this.tagify = undefined
  }
}